import React, { useEffect, useState } from 'react';
import { Button, Table } from 'react-bootstrap';
import { JhiItemCount, JhiPagination, TextFormat, getPaginationState } from 'react-jhipster';
import { Link, useLocation, useNavigate } from 'react-router';

import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';

import { getEntities } from './cliente.reducer';

export const Cliente = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const clienteList = useAppSelector(state => state.cliente.entities);
  const loading = useAppSelector(state => state.cliente.loading);
  const totalItems = useAppSelector(state => state.cliente.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const { order } = paginationState;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="cliente-heading" data-cy="ClienteHeading">
        Clientes
        <div className="d-flex justify-content-end">
          <Button className="me-2" variant="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} /> Refresh list
          </Button>
          <Link to="/cliente/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp; Create a new Cliente
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {clienteList?.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  ID <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('key')}>
                  Key <FontAwesomeIcon icon={getSortIconByFieldName('key')} />
                </th>
                <th className="hand" onClick={sort('nombre')}>
                  Nombre <FontAwesomeIcon icon={getSortIconByFieldName('nombre')} />
                </th>
                <th className="hand" onClick={sort('cuentaBancaria')}>
                  Cuenta Bancaria <FontAwesomeIcon icon={getSortIconByFieldName('cuentaBancaria')} />
                </th>
                <th className="hand" onClick={sort('claveInstitucion')}>
                  Clave Institucion <FontAwesomeIcon icon={getSortIconByFieldName('claveInstitucion')} />
                </th>
                <th className="hand" onClick={sort('tipoCuenta')}>
                  Tipo Cuenta <FontAwesomeIcon icon={getSortIconByFieldName('tipoCuenta')} />
                </th>
                <th className="hand" onClick={sort('numeroCertificado')}>
                  Numero Certificado <FontAwesomeIcon icon={getSortIconByFieldName('numeroCertificado')} />
                </th>
                <th className="hand" onClick={sort('aliasCertificado')}>
                  Alias Certificado <FontAwesomeIcon icon={getSortIconByFieldName('aliasCertificado')} />
                </th>
                <th className="hand" onClick={sort('digitoVerificador')}>
                  Digito Verificador <FontAwesomeIcon icon={getSortIconByFieldName('digitoVerificador')} />
                </th>
                <th className="hand" onClick={sort('pagoComision')}>
                  Pago Comision <FontAwesomeIcon icon={getSortIconByFieldName('pagoComision')} />
                </th>
                <th className="hand" onClick={sort('tipoPago')}>
                  Tipo Pago <FontAwesomeIcon icon={getSortIconByFieldName('tipoPago')} />
                </th>
                <th className="hand" onClick={sort('keySource')}>
                  Key Source <FontAwesomeIcon icon={getSortIconByFieldName('keySource')} />
                </th>
                <th className="hand" onClick={sort('keyPem')}>
                  Key Pem <FontAwesomeIcon icon={getSortIconByFieldName('keyPem')} />
                </th>
                <th className="hand" onClick={sort('certificadoPem')}>
                  Certificado Pem <FontAwesomeIcon icon={getSortIconByFieldName('certificadoPem')} />
                </th>
                <th className="hand" onClick={sort('extra1')}>
                  Extra 1 <FontAwesomeIcon icon={getSortIconByFieldName('extra1')} />
                </th>
                <th className="hand" onClick={sort('extra2')}>
                  Extra 2 <FontAwesomeIcon icon={getSortIconByFieldName('extra2')} />
                </th>
                <th className="hand" onClick={sort('extra3')}>
                  Extra 3 <FontAwesomeIcon icon={getSortIconByFieldName('extra3')} />
                </th>
                <th className="hand" onClick={sort('extra4')}>
                  Extra 4 <FontAwesomeIcon icon={getSortIconByFieldName('extra4')} />
                </th>
                <th className="hand" onClick={sort('extra5')}>
                  Extra 5 <FontAwesomeIcon icon={getSortIconByFieldName('extra5')} />
                </th>
                <th className="hand" onClick={sort('extra6')}>
                  Extra 6 <FontAwesomeIcon icon={getSortIconByFieldName('extra6')} />
                </th>
                <th className="hand" onClick={sort('extra7')}>
                  Extra 7 <FontAwesomeIcon icon={getSortIconByFieldName('extra7')} />
                </th>
                <th className="hand" onClick={sort('extra8')}>
                  Extra 8 <FontAwesomeIcon icon={getSortIconByFieldName('extra8')} />
                </th>
                <th className="hand" onClick={sort('extra9')}>
                  Extra 9 <FontAwesomeIcon icon={getSortIconByFieldName('extra9')} />
                </th>
                <th className="hand" onClick={sort('extra10')}>
                  Extra 10 <FontAwesomeIcon icon={getSortIconByFieldName('extra10')} />
                </th>
                <th className="hand" onClick={sort('createdBy')}>
                  Created By <FontAwesomeIcon icon={getSortIconByFieldName('createdBy')} />
                </th>
                <th className="hand" onClick={sort('createdDate')}>
                  Created Date <FontAwesomeIcon icon={getSortIconByFieldName('createdDate')} />
                </th>
                <th className="hand" onClick={sort('lastModifiedBy')}>
                  Last Modified By <FontAwesomeIcon icon={getSortIconByFieldName('lastModifiedBy')} />
                </th>
                <th className="hand" onClick={sort('lastModifiedDate')}>
                  Last Modified Date <FontAwesomeIcon icon={getSortIconByFieldName('lastModifiedDate')} />
                </th>
                <th>
                  User <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {clienteList.map(cliente => (
                <tr key={`entity-${cliente.id}`} data-cy="entityTable">
                  <td>
                    <Button as={Link as any} to={`/cliente/${cliente.id}`} variant="link" size="sm">
                      {cliente.id}
                    </Button>
                  </td>
                  <td>{cliente.key}</td>
                  <td>{cliente.nombre}</td>
                  <td>{cliente.cuentaBancaria}</td>
                  <td>{cliente.claveInstitucion}</td>
                  <td>{cliente.tipoCuenta}</td>
                  <td>{cliente.numeroCertificado}</td>
                  <td>{cliente.aliasCertificado}</td>
                  <td>{cliente.digitoVerificador}</td>
                  <td>{cliente.pagoComision}</td>
                  <td>{cliente.tipoPago}</td>
                  <td>{cliente.keySource}</td>
                  <td>{cliente.keyPem}</td>
                  <td>{cliente.certificadoPem}</td>
                  <td>{cliente.extra1}</td>
                  <td>{cliente.extra2}</td>
                  <td>{cliente.extra3}</td>
                  <td>{cliente.extra4}</td>
                  <td>{cliente.extra5}</td>
                  <td>{cliente.extra6}</td>
                  <td>{cliente.extra7}</td>
                  <td>{cliente.extra8}</td>
                  <td>{cliente.extra9}</td>
                  <td>{cliente.extra10}</td>
                  <td>{cliente.createdBy}</td>
                  <td>{cliente.createdDate ? <TextFormat type="date" value={cliente.createdDate} format={APP_DATE_FORMAT} /> : null}</td>
                  <td>{cliente.lastModifiedBy}</td>
                  <td>
                    {cliente.lastModifiedDate ? <TextFormat type="date" value={cliente.lastModifiedDate} format={APP_DATE_FORMAT} /> : null}
                  </td>
                  <td>{cliente.user ? cliente.user.login : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button as={Link as any} to={`/cliente/${cliente.id}`} variant="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" /> <span className="d-none d-md-inline">View</span>
                      </Button>
                      <Button
                        as={Link as any}
                        to={`/cliente/${cliente.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        variant="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
                      </Button>
                      <Button
                        onClick={() =>
                          (globalThis.location.href = `/cliente/${cliente.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        variant="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" /> <span className="d-none d-md-inline">Delete</span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && <div className="alert alert-warning">No Clientes found</div>
        )}
      </div>
      {totalItems ? (
        <div className={clienteList && clienteList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Cliente;
